import { Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const CONTACT_EMAIL = 'christian@korutalent.co.uk';
export const EMAIL_HREF = `mailto:${CONTACT_EMAIL}`;

export const EmailButton = (props) => (
  <Button asChild {...props}>
    <a href={EMAIL_HREF}>
      <Mail className="h-4 w-4 shrink-0" aria-hidden="true" />
      Email Us
    </a>
  </Button>
);